import { createBaseInputNamespace } from '../BaseInput';
import { InputTypes } from '../enums/InputTypes';

export const NumberInput = createBaseInputNamespace(InputTypes.Number);
